// Delade cookie-helpers. Tidigare reimplementerade både popup.js och
// latest-products.js var sin variant av get/setCookie — nu ligger den
// generiska logiken här.

/**
 * Sätt en cookie.
 * @param {string} name
 * @param {string} value  Råvärde (encoda själv om det kan innehålla ; eller ,).
 * @param {number} days   Antal dagar tills cookien går ut.
 */
export const setCookie = (name, value, days) => {
    const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString()
    document.cookie = `${name}=${value};expires=${expires};path=/`
}

/**
 * Läs en cookie. Returnerar undefined om den inte finns.
 * @param {string} name
 * @returns {string|undefined}
 */
export const getCookie = (name) => {
    const value = `; ${document.cookie}`
    const parts = value.split(`; ${name}=`)
    if (parts.length === 2) return parts.pop().split(';').shift()
}
